import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import { putTargetApiCrud, type PutTargetRequest } from "@/generated/fastapi";

export async function putTarget(
  accessToken: string | null | undefined,
  request: PutTargetRequest,
) {
  const response = await putTargetApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to update target (${response.status})`);
  }

  return response.data;
}
